import styled from 'styled-components';

import { Button } from '@gympass/yoga';

export const ChatFooterRoot = styled.div`
  padding: ${({ theme }) => theme.yoga.spacing.large}px
    ${({ theme }) => theme.yoga.spacing.large}px;
  width: 100%;
  background-color: ${({ theme }) => theme.yoga.colors.white};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  [contenteditable][placeholder]:empty:before {
    content: attr(placeholder);
    color: ${({ theme }) => theme.yoga.colors.text.secondary};
  }
`;

export const SendButton = styled(Button.Icon)`
  margin-left: ${({ theme }) => theme.yoga.spacing.xsmall}px;
  height: ${({ theme }) => theme.yoga.spacing.xlarge}px;
  min-width: ${({ theme }) => theme.yoga.spacing.xlarge}px;
  width: ${({ theme }) => theme.yoga.spacing.xlarge}px;
  border-radius: ${({ theme }) => theme.yoga.radii.circle}px;
  background-color: ${({ theme }) =>
    theme.yoga.colors.elements.backgroundAndDisabled};

  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    fill: ${({ theme }) => theme.yoga.colors.elements.selectionAndIcons};
  }

  &:not([disabled]):not(:hover):focus {
    box-shadow: none;
  }
`;
